module.exports = "<video ng-if=\"!$ctrl.thumb\" class=\"desktop-video video-viewer\" height=\"100%\" autoplay=\"autoplay\" controls onplay=\"window.angular.element(this).scope().onVideoStarted()\" onended=\"window.angular.element(this).scope().onVideoEnded()\"><source ng-src=\"{{$ctrl.src}}\" type=\"video/MP4\">Your browser does not support HTML video.</video>`<video ng-click=\"$ctrl.thumbClick(fact)\" ng-if=\"$ctrl.thumb\" class=\"desktop-video video-thumb\" height=\"100%\" ng-src=\"{{$ctrl.src}}\" type=\"video/MP4\">Your browser does not support HTML video.</video>`"


//////////////////
// WEBPACK FOOTER
// ./src/facts/video/video-file.component.html
// module id = 346
// module chunks = 0